import { createContext, useContext } from "react";
import type { Theme } from "../lib/theme";

export const ThemeContext = createContext<Theme>("neon");
export const useTheme = (): Theme => useContext(ThemeContext);
